export function sanitizeAttributionHeaderValue(value, maxLength) {
    if (typeof value !== 'string')
        return null;
    const sanitized = makeWellFormed(value
        .replace(/[\u0000-\u001F\u007F]/g, '')
        .trim()
        .slice(0, maxLength));
    return sanitized || null;
}
function makeWellFormed(value) {
    let result = '';
    for (let index = 0; index < value.length; index += 1) {
        const codeUnit = value.charCodeAt(index);
        if (codeUnit >= 0xd800 && codeUnit <= 0xdbff) {
            const nextCodeUnit = value.charCodeAt(index + 1);
            if (nextCodeUnit >= 0xdc00 && nextCodeUnit <= 0xdfff) {
                result += value[index] + value[index + 1];
                index += 1;
            }
            else {
                result += '\uFFFD';
            }
        }
        else if (codeUnit >= 0xdc00 && codeUnit <= 0xdfff) {
            result += '\uFFFD';
        }
        else {
            result += value[index];
        }
    }
    return result;
}
